import React, { useEffect, useState } from 'react';
import { useAppDispatch } from 'hooks';

import { FullPageLoader } from '~components';

import { getFeatureFlag } from '~main/actions/login';

interface ComponentProps {
  Route: React.FC;
  flag: string;
  redirect?: string;
  [key: string]: any;
}

const AppFeatureFlagRoute: React.FC<ComponentProps> = ({ Route, flag, redirect = '/home', ...props }) => {
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    checkFlag();
  }, []);

  const checkFlag = async () => {
    const { payload } = await dispatch(getFeatureFlag({ flag }));

    const { success, data } = payload;

    if (success && data) setIsLoading(false);
    else window.location.replace(redirect);
  };

  return (
    <>
      <FullPageLoader isLoading={isLoading} />
      {!isLoading && <Route {...props} />}
    </>
  );
};

export default AppFeatureFlagRoute;
